module.exports = __webpack_public_path__ + "media/src/images/icons/orange_circle-ad0fdcb40f40e0dbd1e263cd1bddc162.svg";